export default [
  {
    path: '/login',
    component: () => import('@/pages/auth/Login.vue'),
    name: 'auth.login',
    meta: {
      title: 'Login',
      guestOnly: true,
    },
  },
  {
    path: '/forgot-password',
    component: () => import('@/pages/auth/ForgotPassword.vue'),
    name: 'auth.forgot-password',
    meta: {
      title: 'Forgot Password',
      guestOnly: true,
    },
  },
  {
    path: '/password/reset',
    component: () => import('@/pages/auth/PasswordReset.vue'),
    name: 'auth.password-reset',
    meta: {
      title: 'Password Reset',
      guestOnly: true,
    },
  },
  {
    path: '/password-reset-success',
    component: () => import('@/pages/auth/PasswordResetSuccessful.vue'),
    name: 'auth.password-reset-success',
    meta: {
      title: 'Password Reset Successful',
      guestOnly: true,
    },
  },
  {
    path: '/change-password',
    component: () => import('@/pages/auth/ChangePassword.vue'),
    name: 'auth.change-password',
    meta: {
      title: 'Change Password',
      requiresAuth: true,
    },
  },
]
